export default "__VITE_ASSET__CyLkdpq9__"